import { useCallback, useState } from 'react'

function readList(key: string): string[] {
  try {
    const raw = localStorage.getItem(key)
    if (!raw) {
      return []
    }
    const parsed: unknown = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed.filter((item): item is string => typeof item === 'string') : []
  } catch {
    return []
  }
}

function writeList(key: string, list: string[]): void {
  try {
    localStorage.setItem(key, JSON.stringify(list))
  } catch {
    // Private browsing or a full quota should not break the caller's action
  }
}

/** A list of strings kept in this browser for one person, under `${prefix}-${userId}`, re-read when the person changes. */
export function useStoredUserList(prefix: string, userId: string): [string[], (next: string[]) => void] {
  const key = `${prefix}-${userId}`
  const [stored, setStored] = useState(() => ({ key, list: readList(key) }))
  if (stored.key !== key) {
    setStored({ key, list: readList(key) })
  }

  const save = useCallback(
    (next: string[]) => {
      writeList(key, next)
      setStored({ key, list: next })
    },
    [key]
  )

  return [stored.key === key ? stored.list : readList(key), save]
}
